import React from "react";

const footerMessage = () => {
  if (window.location.host === "mourapalha.paguedireto.com.br") {
    return (
      <h6 className="text-[1.5vh]">
        Este serviço é autorizado pelo cartório Moura Palha. Pague Direto
        Serviços Financeiros. CNPJ: 37223553/0001-13
      </h6>
    );
  } else if (
    window.location.host === "1cartoriodefortaleza.paguedireto.com.br"
    // window.location.host === "6protestomanaus.paguedireto.com.br"
  ) {
    return (
      <h6 className="text-[1.5vh]">
        Este serviço é autorizado pelo cartório do Primeiro Ofício de Notas e
        Protes - Fortaleza . Pague Direto Serviços Financeiros. CNPJ:
        06573638/0001-63
      </h6>
    );
  } else if (
    window.location.host === "6protestomanaus.paguedireto.com.br"
  ) {
    return (
      <h6 className="text-[1.5vh]">
        Este serviço é autorizado pelo cartório do 6 Ofício de Protestos e Letras da Comarca da Capital
        - Manaus . Pague Direto Serviços Financeiros. CNPJ:
        37223553/0001-13
      </h6>
    );
  } else {
    return (
      <h6 className="text-[1.5vh]">
        Este serviço é autorizado pelos cartórios contratantes. Pague Direto
        Serviços Financeiros. CNPJ: 37223553/0001-13
      </h6>
    );
  }
};

function AppFooter() {
  return (
    <div
      className="fixed top-[7vh] md:top-[7vh] lg:top-full w-screen 
      xl:mt-[-4.2vh] lg:mt-[-6vh] md:mt-[-7vh] mt-[-7vh] 
        xl:h-[4.2vh] lg:h-[6vh] md:h-[7vh] h-[7vh] bg-black"
    >
      <div className="text-white font-branding font-black flex align-middle justify-center">
        <div className="text-center pt-[1vh]">{footerMessage()}</div>
      </div>
    </div>
  );
}

export default AppFooter;
